import uniqid from 'uniqid'
import LaunchIcon from '@material-ui/icons/Launch'
import './ProjectContainer.css'

const ProjectContainer = ({ article }) => (
  <div className='project'>
    <h3>{article.name}</h3>

    <p className='project__description'>{article.description}</p>
    {article.stack && (
      <ul className='project__stack'>
        {article.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}

    {article.sourceCode && (
      <a
        href={article.sourceCode}
        aria-label='source code'
        className='link link--icon'
        target='_blank'
        rel="noreferrer"
      >
        Read more
        {/* <GitHubIcon /> */}
      </a>
    )}

    {article.livePreview && (
      <a
        href={article.livePreview}
        aria-label='live preview'
        className='link link--icon'
      >
        <LaunchIcon />
      </a>
    )}
  </div>
)

export default ProjectContainer
